import { render, staticRenderFns } from "./ClipsList.vue?vue&type=template&id=c60eac2a&scoped=true"
import script from "./ClipsList.vue?vue&type=script&lang=ts"
export * from "./ClipsList.vue?vue&type=script&lang=ts"
import style0 from "./ClipsList.vue?vue&type=style&index=0&id=c60eac2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60eac2a",
  null
  
)

export default component.exports